import {
  Autocomplete,
  Box,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { desc } from "../../../lib/chartDescription";
import { useRedditSentimentsData } from "../../../lib/hooks";
import {
  listing_options,
  post_catergory_options,
  reddit_table_options,
  time_filter_options,
} from "../../../lib/twitterAPI";
import styles from "./../../../styles/charts/chartStyle.module.css";
import { PieChart, PieChartLoading } from "../protoCharts/PieChart";
import {
  getChartBottomIcons,
  getChartInfoIcons,
} from "../twitter/TwitterWordCloud";

const labelsValue = {
  neu: "Neutral",
  pos: "Positive",
  neg: "Negative",
};

export default function RedditSentiments() {
  const [chartData, setChartData] = useState<{
    data: any[];
    labels: any[];
  } | null>(null);

  const [sentiments, setSentiments] = useState<string | undefined>(undefined);

  const [postCategory, setpostCategory] = useState(post_catergory_options[0]);

  const [timeFilter, settimeFilter] = useState(time_filter_options[0]);

  const [listing, setListing] = useState(listing_options[0]);

  const [redditTable, setRedditTable] = useState(reddit_table_options[0]);

  const { sentimentsData, loading, error } = useRedditSentimentsData({
    post_category: postCategory,
    time_filter: timeFilter,
    listing,
    reddit_table: redditTable,
  });

  useEffect(() => {
    let data: any[] = [];
    let labels: any[] = [];
    if (!loading && error === null) {
      setSentiments(sentimentsData[0].key);
      sentimentsData[0].items.forEach((item: any) => {
        data.push(item.count);
        labels.push(labelsValue[item.sentiment as "neu"]);
      });
      setChartData({ data, labels });
    }
    //eslint-disable-next-line
  }, [loading]);

  useEffect(() => {
    let data: any[] = [];
    let labels: any[] = [];

    // debugger;
    sentiments !== undefined &&
      sentimentsData
        .filter((item) => item.key === sentiments)[0]
        .items.forEach((item: any) => {
          data.push(item.count);
          labels.push(labelsValue[item.sentiment as "neu"]);
        });
    setChartData({ data, labels });
    //eslint-disable-next-line
  }, [sentiments]);

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };

  const content = (showMaxButton: boolean) => {
    return (
      <Paper elevation={3} className={styles.chartContainer}>
        <div className="horizontalCenter">
          <Typography className={styles.chartHeader}>
            {"Reddit Sentiment"}
          </Typography>
        </div>
        <div className="horizontalCenter">
          <div className={styles.selectOptionRow}>
            <Autocomplete
              // autoComplete
              id="combo-box-demo"
              fullWidth
              options={post_catergory_options}
              // isOptionEqualToValue={(option, value) => option.label === value}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: string | null) => {
                // setValue(newValue);
                setpostCategory(newValue as string);
                // console.log(newValue);
              }}
              disableClearable
              value={postCategory as string}
              renderInput={(params) => (
                <TextField
                  {...params}
                  // can be used to style  input later on
                  // InputProps={{ style: { fontSize: 14 } }}
                  label="Post Category"
                />
              )}
            />

            {["Controversial Posts", "Top Posts", "Keyword Posts"].includes(
              postCategory
            ) && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={time_filter_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  settimeFilter(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={timeFilter as string}
                renderInput={(params) => (
                  <TextField {...params} label="Time Filter" />
                )}
              />
            )}
            {"Keyword Posts" === postCategory && (
              <Autocomplete
                // autoComplete
                fullWidth
                id="combo-box-demo"
                options={listing_options}
                // isOptionEqualToValue={(option, value) => option.label === value}
                // sx={{ width: "40%" }}
                sx={{ width: "220px" }}
                size={"small"}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setListing(newValue as string);
                  // console.log(newValue);
                }}
                disableClearable
                value={listing as string}
                renderInput={(params) => (
                  <TextField {...params} label="Listing" />
                )}
              />
            )}
            <Autocomplete
              // autoComplete
              fullWidth
              id="combo-box-demo"
              options={reddit_table_options}
              // isOptionEqualToValue={(option, value) =>
              //   option.label === value.label
              // }
              // sx={{ width: "40%" }}
              sx={{ width: "220px" }}
              size={"small"}
              onChange={(event: any, newValue: any) => {
                // setValue(newValue);
                setRedditTable(newValue);
                // console.log(newValue);
              }}
              disableClearable
              value={redditTable}
              renderInput={(params) => (
                <TextField {...params} label="Reddit Table" />
              )}
            />

            {sentiments && (
              <Autocomplete
                // autoComplete
                id="combo-box-demo"
                options={sentimentsData.map((item) => item.key)}
                // isOptionEqualToValue={(option, value) => option.label === value}
                className={styles.flexAutoComplete}
                size={"small"}
                sx={{ width: "220px" }}
                onChange={(event: any, newValue: string | null) => {
                  // setValue(newValue);
                  setSentiments(newValue as string);
                  console.log(newValue);
                }}
                disableClearable
                value={sentiments as string}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Keyword"
                    // InputProps={{ style: { fontSize: 12 } }}
                  />
                )}
              />
            )}
          </div>
        </div>
        <div style={{ width: "100%" }}>
          <>
            {loading && (
              <Box className={styles.center}>
                <PieChartLoading />
              </Box>
            )}
            {!loading && chartData?.data && chartData?.labels && (
              <PieChart
                chartData={chartData?.data}
                labels={chartData?.labels as any[]}
                type="donut"
              />
            )}
          </>
          {getChartBottomIcons(showMaxButton, setOpen)}
          {getChartInfoIcons(desc["twitter"]["sentiment"])}
        </div>
      </Paper>
    );
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={styles.fullScreenPieChart}>{content(false)}</Box>
      </Modal>
      {content(true)}
    </>
  );
}
